import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "./components/ui/toaster";
import LoginPage from "./pages/LoginPage";
import SSOCallbackPage from "./pages/SSOCallbackPage";
import WorkflowPage from "./pages/WorkflowPage";
import WorkflowDetailPage from "./pages/WorkflowDetailPage";
import LogsPage from "./pages/LogsPage";
import { useAuthStore } from "./store/useAuthStore";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <Router>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
      >
        <div className="min-h-screen bg-background">
          <Routes>
            <Route
              path="/"
              element={
                isAuthenticated ?
                  <Navigate to="/workflows" replace /> :
                  <LoginPage />
              }
            />
            <Route
              path="/sso/auth"
              element={<SSOCallbackPage />}
            />
            <Route
              path="/workflows"
              element={
                <ProtectedRoute>
                  <WorkflowPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/workflow"
              element={
                <ProtectedRoute>
                  <WorkflowPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={<Navigate to="/workflows" replace />}
            />
            <Route
              path="/workflows/ontology/:id"
              element={
                <ProtectedRoute>
                  <WorkflowDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/workflows/process/:id"
              element={
                <ProtectedRoute>
                  <WorkflowDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/logs"
              element={
                <ProtectedRoute>
                  <LogsPage />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster />
        </div>
      </ThemeProvider>
    </Router>
  );
}

export default App;
